<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <strong>Thông tin danh mục</strong>
          </div>
          <b-form @submit.prevent="save">
            <b-row>
              <b-col>
                <b-form-group
                  label="Tên danh mục cha:"
                  label-for="parentId"
                  :label-cols="4"
                  :horizontal="true"
                  label-align="right"
                >
                  <!--<b-form-input type="text" id="parentId"
                                                  class="col-6"
                                                  aria-describedby="codeFeedback"
                                                  v-model="category.parentId">
                                    </b-form-input>-->
                  <treeselect
                    class="col-6 no-padding"
                    id="parentId"
                    v-if="editing && categories.length > 0"
                    v-model="category.parentId"
                    placeholder="--- Chọn ---"
                    :options="categories"
                  />
                  <label class="col-form-label col-6" v-if="!editing">{{
                    category.parentName
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Tên danh mục:"
                  label-for="name"
                  :label-cols="4"
                  :horizontal="true"
                  label-align="right"
                  :label-class="editing ? 'required' : ''"
                >
                  <b-form-input
                    type="text"
                    id="name"
                    v-if="editing"
                    class="col-6"
                    aria-describedby="codeFeedback"
                    v-model="$v.category.name.$model"
                    :state="
                      $v.category.name.$dirty ? !$v.category.name.$error : null
                    "
                  >
                  </b-form-input>
                  <b-form-invalid-feedback id="codeFeedback">
                    Vui lòng nhập tên danh mục
                  </b-form-invalid-feedback>
                  <label class="col-form-label col-6" v-if="!editing">{{
                    category.name
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Tiêu đề:"
                  label-for="title"
                  :label-cols="4"
                  :horizontal="true"
                  label-align="right"
                  :label-class="editing ? 'required' : ''"
                >
                  <b-form-input
                    type="text"
                    id="title"
                    v-if="editing"
                    class="col-6"
                    aria-describedby="codeFeedback"
                    v-model="$v.category.title.$model"
                    :state="
                      $v.category.title.$dirty
                        ? !$v.category.title.$error
                        : null
                    "
                  >
                  </b-form-input>
                  <b-form-invalid-feedback id="codeFeedback">
                    Vui lòng nhập tiêu đề
                  </b-form-invalid-feedback>
                  <label class="col-form-label col-6" v-if="!editing">{{
                    category.title
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Tên không dấu:"
                  label-for="slug"
                  :label-cols="4"
                  :horizontal="true"
                  label-align="right"
                >
                  <b-form-input
                    type="text"
                    id="slug"
                    v-if="editing"
                    class="col-6"
                    aria-describedby="codeFeedback"
                    v-model="category.slug"
                  >
                  </b-form-input>
                  <label class="col-form-label col-6" v-if="!editing">{{
                    category.slug
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Mô tả:"
                  label-for="description"
                  :label-cols="4"
                  :horizontal="true"
                  label-align="right"
                  :label-class="editing ? 'required' : ''"
                >
                  <b-form-input
                    type="text"
                    id="description"
                    v-if="editing"
                    class="col-6"
                    aria-describedby="codeFeedback"
                    v-model="$v.category.description.$model"
                    :state="
                      $v.category.description.$dirty
                        ? !$v.category.description.$error
                        : null
                    "
                  >
                  </b-form-input>
                  <b-form-invalid-feedback id="codeFeedback">
                    Vui lòng nhập mô tả
                  </b-form-invalid-feedback>
                  <label class="col-form-label col-6" v-if="!editing">{{
                    category.description
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Hình ảnh:"
                  label-for="urlImage"
                  :label-cols="4"
                  :horizontal="true"
                  label-align="right"
                >
                  <!-- <b-form-input type="text" id="urlImage" v-if="editing"
                                                  class="col-6"
                                                  aria-describedby="codeFeedback"
                                                  v-model="category.urlImage"> 
                                    </b-form-input>-->

                  <b-form-file
                    v-model="category.file"
                    v-if="editing"
                    class="col-6 no-padding"
                    accept="image/*"
                    browse-text="Chọn"
                    placeholder="Chọn tệp tải lên..."
                  >
                  </b-form-file>
                  <!-- <label class="col-form-label col-6" v-if="!editing">
                    {{ this.getUrlImage(category.urlImage) }}
                  </label> -->
                  <img
                    v-if="!editing"
                    :src="this.getUrlImage(category.urlImage)"
                    style="width: 200px"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="MetaTitle:"
                  label-for="MetaTitle"
                  :label-cols="4"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-textarea
                    v-model="$v.category.metaTitle.$model"
                    :state="
                      $v.category.metaTitle.$model &&
                      $v.category.metaTitle.$dirty
                        ? !$v.category.metaTitle.$error
                        : null
                    "
                    v-if="editing"
                    class="col-6"
                    id="MetaTitle"
                    rows="3"
                  ></b-form-textarea>
                  <b-form-invalid-feedback
                    v-if="!$v.category.metaTitle.maxLength"
                  >
                    Không được quá 256 ký tự !
                  </b-form-invalid-feedback>
                  <label class="col-form-label col-6" v-if="!editing">{{
                    category.metaTitle
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="MetaKeywords:"
                  label-for="MetaKeywords"
                  :label-cols="4"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-textarea
                    v-model="$v.category.metaKeywords.$model"
                    :state="
                      $v.category.metaKeywords.$model &&
                      $v.category.metaKeywords.$dirty
                        ? !$v.category.metaKeywords.$error
                        : null
                    "
                    v-if="editing"
                    class="col-6"
                    id="MetaKeywords"
                    rows="3"
                  ></b-form-textarea>
                  <b-form-invalid-feedback
                    v-if="!$v.category.metaKeywords.maxLength"
                  >
                    Không được quá 256 ký tự !
                  </b-form-invalid-feedback>
                  <label class="col-form-label col-6" v-if="!editing">{{
                    category.metaKeywords
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="MetaDescriptions:"
                  label-for="MetaDescriptions"
                  :label-cols="4"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-textarea
                    v-model="$v.category.metaDescriptions.$model"
                    :state="
                      $v.category.metaDescriptions.$model &&
                      $v.category.metaDescriptions.$dirty
                        ? !$v.category.metaDescriptions.$error
                        : null
                    "
                    v-if="editing"
                    class="col-6"
                    id="MetaDescriptions"
                    rows="3"
                  ></b-form-textarea>
                  <b-form-invalid-feedback
                    v-if="!$v.category.metaDescriptions.maxLength"
                  >
                    Không được quá 256 ký tự !
                  </b-form-invalid-feedback>
                  <label class="col-form-label col-6" v-if="!editing">{{
                    category.metaDescriptions
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Trạng thái:"
                  label-align="right"
                  label-for="status"
                  :label-cols="4"
                  :horizontal="true"
                >
                  <b-form-checkbox
                    id="status"
                    v-if="editing"
                    v-model="category.status"
                    class="col-6 col-form-label"
                  ></b-form-checkbox>
                  <label class="col-form-label col-6" v-if="!editing">{{
                    $store.getters.getStatusName(category.status ? 1 : 0)
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Hiển thị trên trang chủ:"
                  label-align="right"
                  label-for="isshowhome"
                  :label-cols="4"
                  :horizontal="true"
                >
                  <b-form-checkbox
                    id="isshowhome"
                    v-if="editing"
                    v-model="category.isShowHome"
                    class="col-6 col-form-label"
                  ></b-form-checkbox>
                  <label class="col-form-label col-6" v-if="!editing">{{
                    $store.getters.getStatusName(category.isShowHome ? 1 : 0)
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="" :label-cols="4">
                  <!--<b-button type="button" variant="primary" @click="edit" v-if="!editing ">Sửa</b-button>-->
                  <b-button
                    type="button"
                    variant="secondary"
                    @click="back"
                    v-if="!editing"
                    >Quay lại</b-button
                  >
                  <b-button
                    type="submit"
                    variant="primary"
                    v-if="editing && authorize(['ManageCategory'])"
                    >Ghi lại</b-button
                  >
                  <b-button
                    type="button"
                    variant="secondary"
                    @click="cancel"
                    v-if="editing"
                    >Hủy</b-button
                  >
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { authorizationMixin } from "@/shared/mixins";

export default {
  name: "categoryDetail",
  mixins: [validationMixin, authorizationMixin],
  data() {
    return {
      category: {},
      editing: this.$route.meta.editing,
    };
  },
  computed: {
    categoryId() {
      return this.$route.params.categoryId;
    },
    ...mapState({
      categories: (state, getters) => getters.categoryTree,
    }),
  },
  validations: {
    category: {
      name: {
        required,
        maxLength: maxLength(128),
      },
      title: {
        required,
        //maxLength: maxLength(128)
      },
      description: {
        required,
        //maxLength: maxLength(128)
      },

      metaTitle: {
        maxLength: maxLength(256),
      },
      metaKeywords: {
        maxLength: maxLength(256),
      },
      metaDescriptions: {
        maxLength: maxLength(256),
      },
    },
  },
  watch: {
    //'unitType.code'(newVal) {
    //    this.checkExistCode(newVal);
    //}
    "category.name"(value) {
      this.category.slug = value.convertslug();
    },
  },
  created() {
    this.loadcategoryDetail();
  },
  methods: {
    loadcategoryDetail() {
      var vm = this;
      return this.$services
        .get(`master-data/categories/${this.categoryId}`)
        .done((category) => {
          vm.category = category;
        });
    },
    edit() {
      this.editing = true;
    },
    back() {
      this.$router.push({ path: "/master-data/categories" });
    },
    cancel() {
      var vm = this;
      this.loadcategoryDetail().done(() => (vm.editing = false));
    },
    save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var vm = this;
        this.$services
          .upload(`master-data/categories/${this.categoryId}`, this.category)
          .done(() => {
            vm.$toastr.s("Cập nhật danh mục thành công");
            vm.cancel();
          });
      }
    },
    checkExistCode(newVal) {
      if (newVal) {
        //var vm = this;
        //this.$services.get(`master-data/existing-unit-types-code/${newVal}/${this.unitType.id || null}`).done(returnData => {
        //    if (!returnData) {
        //        this.codeUnique = "required";
        //    }
        //    else {
        //        this.codeUnique = "";
        //    }
        //});
      } else {
        this.codeUnique = "required";
      }
    },
    getUrlImage(path) {
      return this.$services.getResourceUrl() + path;
    },
  },
};
</script>
<style scoped>
</style>
